module.exports = __webpack_public_path__ + "img/arrow_download.376dd6de.svg";